<template>
  <div>
  </div>
</template>

<script>
export default {
  name: 'loading',
  data(){
    return{
    }
  },
  mounted:function(){
    this.gotoForm();
  },
  methods:{
    gotoForm(){
      var historyData = this.$session.get('historyData');
      if(historyData.view_cd === 'reachSimulation'){
        // console.log('reachSimulation ||||||||| ');
        // console.log(historyData.formData);
        this.$session.set('inputFormData', historyData.formData);
        this.$router.push("/reach/reach")
      }else if(historyData.view_cd === 'reachSimulationDA'){
        this.$session.set('inputFormData', historyData.formData);
        this.$router.push("/reach/da/reach")        
      }else if(historyData.view_cd === 'budgetAllocation'){
        // console.log('budgetAllocation ||||||||| ');
        this.$session.set('budgetFormData', historyData.formData);
        this.$router.push("/budget/budget")
      }
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/pages/Loading.vue